const getApiUrl = (backend) => {
    if(backend) {
        return `${process.env.REACT_APP_BACKEND_PROTOCOL}://${backend}.${process.env.REACT_APP_BACKEND_URL}`
    }
    return `${process.env.REACT_APP_BACKEND_PROTOCOL}://${process.env.REACT_APP_BACKEND_URL}`
}

export default getApiUrl;